import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useCallback, useState } from "react";
import { useIntl } from "react-intl";
import { UncontrolledTooltip } from "reactstrap";
import ContactOnlineInfoModal from "./modal/ContactOnlineInfoModal";
import "./ContactResearchActions.scss";

export interface ContactResearchContact {
  id: string;
  name?: string;
  email?: string;
  phoneNumber?: string;
  whatsapp?: string;
  companies?: Array<{ name?: string }>;
}

interface Props {
  contact: ContactResearchContact;
}

export default function ContactResearchButton({ contact }: Props) {
  const intl = useIntl();
  const [open, setOpen] = useState(false);
  const tipId = `contact-research-${contact.id}`;

  const onOpen = useCallback((event: React.MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();
    setOpen(true);
  }, []);

  return (
    <>
      <button
        type="button"
        id={tipId}
        className="contact-research-icon"
        onClick={onOpen}
        aria-label={intl.formatMessage({
          id: "app.crmBusiness.contactResearch.investigate",
        })}
      >
        <FontAwesomeIcon icon={["fas", "globe"]} />
      </button>
      <UncontrolledTooltip placement="top" target={tipId} delay={{ show: 200, hide: 0 }}>
        {intl.formatMessage({
          id: "app.crmBusiness.contactResearch.investigate",
        })}
      </UncontrolledTooltip>

      <ContactOnlineInfoModal
        isOpen={open}
        contactId={contact.id}
        fallback={{
          name: contact.name,
          email: contact.email,
          phone: contact.phoneNumber || contact.whatsapp,
          companyName: contact.companies?.[0]?.name,
        }}
        onClose={() => setOpen(false)}
      />
    </>
  );
}
